import React, { useState } from "react";
import "./Dashboard.css";
import { motion } from "framer-motion";
import { Button, TextField, Typography } from "@mui/material";
import { useStateContext } from "../contexts/ContextProvider";
import { useMutation, gql } from "@apollo/client";
import { useNavigate } from "react-router-dom";


const LOGIN_MUTATION = gql`
  mutation Login($identifier: String!, $password: String!) {
    login(input: { identifier: $identifier, password: $password }) {
      jwt
      user {
        id
        username
        email
      }
    }
  }
`;

// Define animation
const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.8 } },
};

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { activeMenu,setIsLogged,setProfileVisible } = useStateContext(); // Access activeMenu state

  const [login, { loading }] = useMutation(LOGIN_MUTATION);
  const navigate = useNavigate();


  const handleLogin = async () => {
    try {
      const { data } = await login({
        variables: { identifier: username, password },
      });

      if (data && data.login.jwt) {
        localStorage.setItem("jwt", data.login.jwt);
        localStorage.setItem("userId", data.login.user.id);
        localStorage.setItem("username", data.login.user.username);
        localStorage.setItem("user_mail", data.login.user.email);

        setIsLogged(true);
        setProfileVisible(false);
        setErrorMessage(""); // Clear any previous errors
        navigate("/Dashboard");  // Redirect to home
      }
    } catch (err) {
      console.error("Login error:", err);
      setErrorMessage("Invalid username or password.");
    }
  };

  return (
    <div className="dashboard">
      <div id="base">
        {/* Page Content */}
        <div className="content mt-4">
          <div className="grid-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            {/* Login Form */}
            <motion.div
              style={{
                width: "100%",
                maxWidth: "400px",
                borderColor: "rgba(156, 163, 175, 0.5)",
                borderWidth: "2px",
                borderStyle: "solid",
                transition: "all 0.3s ease",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "1rem",
                borderRadius: "12px",
                background: "rgba(0, 0, 0, 0.6)",
                backdropFilter: "blur(10px)",
                borderImage:
                  "linear-gradient(to right, #8018e7, #10b981, #3b82f6) 1",
              }}
              variants={fadeIn}
              initial="hidden"
              animate="visible"
            >
              <Typography variant="h5" sx={{ color: "#fff", mt: 1}}>
                Login
              </Typography>
              <Typography variant="body2" sx={{ color: "#6b7280", mb: 1 }}>
                Using some tools might require login
              </Typography>
              <TextField
                label="Username"
                size="small"
                variant="outlined"
                margin="normal"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                sx={{
                  background: "#FFFFFF00",
                  borderRadius: "4px",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#6b7280" }, // Default border gray-500
                    "&:hover fieldset": { borderColor: "#6b7280" }, // On hover
                    "&.Mui-focused fieldset": { borderColor: "#a855f7" }, // Focused border purple-500
                  },
                  "& .MuiInputBase-input": {
                    color: "#fff", // Text color white
                  },
                  "& .MuiInputLabel-root": {
                    color: "#6b7280", // Label color gray-500
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#a855f7", // Label color purple-500 on focus
                  },
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#a855f7", // Ensure border is purple-500 on focus
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#6b7280", // Placeholder color gray-500
                    opacity: 1,
                  },
                }}
              />

            <TextField
              label="Password"
              type="password"
              size="small"
              variant="outlined"
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={Boolean(errorMessage)} // Show red border if error exists
              helperText={errorMessage} // Show error message below input
              sx={{
                background: "#FFFFFF00",
                borderRadius: "4px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: errorMessage ? "#f44336" : "#6b7280",
                  },
                  "&:hover fieldset": { borderColor: "#6b7280" },
                  "&.Mui-focused fieldset": {
                    borderColor: errorMessage ? "#f44336" : "#a855f7",
                  },
                },
                "& .MuiInputBase-input": { color: "#fff" },
                "& .MuiInputLabel-root": { color: "#6b7280" },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: errorMessage ? "#f44336" : "#a855f7",
                },
                "& .MuiFormHelperText-root": { color: "#f44336" },
              }}
            />
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  background:
                    "linear-gradient(to right, #8018e7, #10b981, #3b82f6)",
                  color: "#fff",
                }}
                onClick={handleLogin}
              >
                Login
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 2, cursor: "pointer", color: "#bbb" }}
                onClick={() => alert("Forgot Password Clicked")}
              >
                Forgot Password?
              </Typography>
            </motion.div>
          </div>
        </div>


        {/* Background Layers */}
        <div
          id="hey"
          className="w-full bg-[#011] absolute right-0 left-0 mx-auto z-10 transform perspective-[200px]
            desktop1280:bottom-[27.3vh] desktop1440:bottom-[28vh] 
            desktop1600:bottom-[28vh] desktop1920:bottom-[27vh]"
        >
          <div id="layer-up"></div>
        </div>

        <div
          id="layer-0"
          className={`${activeMenu ? "w-[calc(200vw-28rem)]" : "w-[200vw]"}`}
        >
          <div id="layer-1">
            <div id="layer-2">
              <div id="lines">
                <div id="layer-corner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
